import React, { useState, useEffect } from "react";
import { Box, Grid, Fab } from "@material-ui/core";
import FileDownloadIcon from "@material-ui/icons/GetApp";
import ValidatedInput from "../components/ValidatedInput";
import DateRangeInput from "../components/DateRangeInput";
import translate from "../i18n/Translator";

interface UnloadedInvoicesFiltersProps {
    paymentMethod: string;
    period: string;
    canRead: boolean;
    cardsLoading: boolean;
    hasResults: boolean;
    onPaymentMethodChanged: (name: string, value: string) => void;
    onPeriodChanged: (startDate?: Date, endDate?: Date, formatted?: string) => void;
    onDownloadExcel: () => void;
    filterInputClass: string;
    dateInputClass: string;
    idSuffix?: string;
    initialPeriod?: string;
    inputKey?: number;
}

const UnloadedInvoicesFilters: React.FC<UnloadedInvoicesFiltersProps> = ({
    paymentMethod,
    period,
    canRead,
    cardsLoading,
    hasResults,
    onPaymentMethodChanged,
    onPeriodChanged,
    onDownloadExcel,
    filterInputClass,
    dateInputClass,
    idSuffix = "",
    initialPeriod,
    inputKey = 0
}) => {
    const handlePeriodChange = (startDate?: Date, endDate?: Date, formatted?: string) => {     
        if (!startDate && !endDate && !formatted && period === initialPeriod) {
            return; 
        }
        onPeriodChanged(startDate, endDate, formatted);
    };
    return (
        <>
            <Box className={filterInputClass}>
                <ValidatedInput
                    type="text"
                    id={`paymentMethod${idSuffix}`}
                    name={`paymentMethod${idSuffix}`}
                    label={translate("cfdis.cfdis_non_integrated.filters.payment_method") as string}
                    margin="dense"
                    disabled={false}
                    value={paymentMethod}
                    onValueChanged={onPaymentMethodChanged}
                    options={[
                        translate("cfdis.cfdis_non_integrated.filters.optionPUE") as string, 
                        translate("cfdis.cfdis_non_integrated.filters.optionPPD") as string
                    ]}
                    optionLabels={[
                        translate("cfdis.cfdis_non_integrated.filters.optionPUEtext") as string,
                        translate("cfdis.cfdis_non_integrated.filters.optionPPDtext") as string
                    ]}
                />
            </Box>
            <Box className={dateInputClass}>
                <DateRangeInput
                    key={inputKey}
                    id={`period${idSuffix}`}
                    label={translate("cfdis.cfdis_non_integrated.filters.period") as string}
                    value={period}
                    onChange={handlePeriodChange}
                    disabled={false}
                    maxDate={new Date()}
                    margin="dense"
                    tooltip={translate("cfdis.cfdis_non_integrated.tooltips.period_selection") as string}
                />
            </Box>
            <Grid item xs="auto">
                <Fab 
                    color="primary" 
                    size="small" 
                    title={translate("cfdis.cfdis_non_integrated.tooltips.download_excel") as string}
                    onClick={onDownloadExcel} 
                    disabled={!canRead || cardsLoading || !hasResults}
                >
                    <FileDownloadIcon />
                </Fab>
            </Grid>
        </>
    );
};

export default UnloadedInvoicesFilters;